import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import { Button } from 'react-bootstrap';

import { Report } from 'services/action';

import { Page } from 'ui/components';
import {
  SkeletonTable,
  Skeletons,
  SkeletonPageFooter,
} from 'ui/components/skeleton';

import useTable from 'ui/components/table';

import tableConfig from './component/table.config';
import Filter from './component/filter';
import { currencyFormat } from 'utilities/common';

const initialState = {
  summary: null,
  displayFilter: false,
  count: [],
};

const PayableScreen = () => {
  const Dispatch = useDispatch();
  const ConfigTable = useTable('payable', tableConfig);
  const StateTable = useSelector((state) => state?.Table?.data['payable']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ summary, displayFilter, count }, setState] =
    React.useState(initialState);

  const $loadSummary = async (e) => {
    const result = await Dispatch(Report.$payableSummary(StateTable?.filter));
    if (result?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        summary: result?.data
      }));
    }
  };

  React.useEffect(() => {
    if (!StateLoading) {
      $loadSummary();
    }

  }, [StateLoading]);

  return (
    <Page className="fixed ">
      <Page.Header
        pretitle="Daftar"
        title={'Payable'}
        isLoading={StateLoading}
        action={{ url: '/payable/create', text: 'Buat Payable Baru' }}
      />

      <div className="row p-2 justify-content-center">
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {currencyFormat(summary?.subtotal_charges || 0)}
            </div>
            <div className="page-pretitle text-secondary">Total Hutang</div>
          </div>
        </div>
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-success">
              {currencyFormat(summary?.subtotal_paid || 0)}
            </div>
            <div className="page-pretitle text-success">Total Dibayar</div>
          </div>
        </div>
        <div className="col-2 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className={`fs-5 fw-semibold text-left ${summary?.subtotal_payable > 0 ? 'text-danger': 'text-primary'}`}>
              {currencyFormat(summary?.subtotal_payable || 0)}
            </div>
            <div className={`page-pretitle ${summary?.subtotal_payable > 0 ? 'text-danger': 'text-primary'}`}>Perlu Dibayarkan</div>
          </div>
        </div>
      </div>
      <Page.Navigation toolbar>
        <ConfigTable.Tools downloadable isLoading={StateLoading}>
          {StateLoading ? (
            <div className="ms-2">
              <Skeletons height="35px" width="50px" />
            </div>
          ) : (
            <Button
              variant={displayFilter ? 'primary' : 'secondary'}
              className="ms-2 position-relative"
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  displayFilter: !displayFilter,
                }))
              }
            >
              <Fi.FiFilter size={19} color="white" />
              {count?.length > 0 ? (
                <span className="position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-danger">
                  {count?.length}
                </span>
              ) : null}
            </Button>
          )}
        </ConfigTable.Tools>
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div
          className={cn(
            displayFilter ? 'col-md-9  m-0 p-0' : 'col-md-12   m-0 p-0'
          )}
        >
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={9} />
          ) : (
            <ConfigTable.Render />
          )}
        </div>

        <Filter
          ConfigTable={ConfigTable}
          onClose={() =>
            setState((prevState) => ({
              ...prevState,
              displayFilter: false,
            }))
          }
          show={displayFilter}
          setCount={(x) =>
            setState((prevState) => ({
              ...prevState,
              count: x,
            }))
          }
        />
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <ConfigTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default PayableScreen;
